import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import categoriaService from '../../../service/administracion/categoriaService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            padres: [],
            niveles: [
                { id: 1, nombre: "Nivel 1: Segmento" },
                { id: 2, nombre: "Nivel 2: Familia " },
                { id: 3, nombre: "Nivel 3: Clase " },
                { id: 4, nombre: "Nivel 4: Producto " }
            ],
            estados: estadoMock.values,
            filter: {
                nombre: "",
                idPadre: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: "",
            idNivel: 0,
            numero: '',
            idPadre: 0,
            niveles: [],
            asignar: false,
            label: '',
            codigo: '',
            codigoPadre:'',
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombre: "",
            idPadre: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleLoadData = (treeNode) => {
        console.log(treeNode);
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await categoriaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Categoria.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await categoriaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Categoria.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await categoriaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await categoriaService.eliminar(values);
            else
                response = await categoriaService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(
                    <ul>
                        {response.data.messages.map((item) => (
                            <li>{item}</li>
                        ))}
                    </ul>
                );
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.niveles = this.state.niveles;

        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        var formValues = this.fetchEmptyFormValues();
        formValues.niveles = this.state.niveles;
        formValues.id = values.id;
        formValues.nombre = values.nombre;
        formValues.codigo = values.codigo;
        formValues.idNivel = values.numero;
        this.setState({ visible: true, formValues });

    };

    handleAsing = async (values) => {
        debugger
        if (values.numero == 4) {
            dialog.info('No se puede agregar ya es productos final');

            return;
        }
        let nextPos = values.numero + 1;
        var formValues = this.fetchEmptyFormValues();
        formValues.idPadre = values.id;
        formValues.asignar = true;
        formValues.label = values.ruta;
        formValues.codigoPadre = values.codigo;

        /*        this.state.niveles.forEach(element => {
                   if (values.numero < element.id) {
                       formValues.niveles.push(element);
                   }
               }); */

        formValues.niveles = this.state.niveles.filter(e => e.id == nextPos);
        this.setState({ visible: true, formValues });


    };


    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await categoriaService.registrar(values);
            else
                response = await categoriaService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, categoriaService.paginacion);
        const padres = await categoriaService.listar();

        this.setState({
            loadingSource: false,
            padres: padres ? padres : [],

            tipoestablecimiento: []

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Categoria"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    padres={this.state.padres}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    onLoadData={this.handleLoadData}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onAsing={this.handleAsing}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}